import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { useUpdateProfile } from '@/hooks/useAuth';
import { setLocale, type SupportedLocale } from '@/locales/i18n';

export function OnboardingPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [name, setName] = useState('');
  const updateProfile = useUpdateProfile();

  const finish = async () => {
    await updateProfile.mutateAsync({
      name,
      locale: (i18n.language?.slice(0, 2) as SupportedLocale) ?? 'ru',
    });
    navigate('/', { replace: true });
  };

  return (
    <Card title={t('auth.welcome')}>
      {step === 1 && (
        <div className="space-y-3">
          <p className="text-sm text-slate-600">{t('auth.choose_language')}</p>
          <div className="flex gap-2">
            <Button onClick={() => setLocale('ru')} variant="secondary">
              Русский
            </Button>
            <Button onClick={() => setLocale('kk')} variant="secondary">
              Қазақша
            </Button>
          </div>
          <Button onClick={() => setStep(2)} className="w-full">
            {t('common.next')}
          </Button>
        </div>
      )}
      {step === 2 && (
        <div className="space-y-3">
          <Input
            label={t('auth.your_name')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
          <Button
            className="w-full"
            disabled={!name.trim()}
            onClick={() => void finish()}
            loading={updateProfile.isPending}
          >
            {t('common.done')}
          </Button>
        </div>
      )}
    </Card>
  );
}
